module.exports = {"name":"Zabudnuté heslo","icon":"<i class='material-icons'>perm_identity</i>","widget":[{"type":"password-forgotten","schemas":{},"initData":{}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/password-forgotten/password-forgotten.json
// module id = 376
// module chunks = 0